import { render } from "./toast.vue?vue&type=template&id=4dde5de4&ts=true"
import script from "./toast.vue?vue&type=script&lang=ts"
export * from "./toast.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__